import {
  Card,
  Flex,
  Heading,
  Icon,
  Text,
  TextIcon,
} from '@weareberyl/design-system'
import { Col, Row } from 'antd'

import HeadTitle from '~/components/HeadTitle'
import ExternalLink from '~/components/Navigation/ExternalLink'

// The availability dashboard lives on Looker; the link opens in a new tab and
// Looker's own session is the gate on the data.
const LOOKER_AVAILABILITY_DASHBOARD_URL =
  'https://berylcc.eu.looker.com/embed/dashboards/internal_kpis::availability'

const DashboardsPage = () => (
  <>
    <HeadTitle pageTitle="Dashboards" />
    <Card mb={4} p={5} pb={3} flex={1}>
      <Heading mb={3} variant="callout">
        Dashboards
      </Heading>
      <TextIcon
        icon={
          <Icon
            color="grape"
            height={14}
            type="information"
            width={14}
            mt={1}
          />
        }
      >
        <Text variant="small" color="grape">
          These dashboards are hosted on Looker. Sign in with the Looker{' '}
          <em>Internal KPIs Viewer</em> user to view them.
        </Text>
      </TextIcon>
    </Card>
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={12}>
        <Card p={5}>
          <Flex flexDirection="col" alignItems="flex-start">
            <Heading mb={2} variant="h1">
              Availability
            </Heading>
            <Text mb={5}>Vehicle availability against targets, by scheme.</Text>
            <ExternalLink
              onPress={() =>
                window.open(LOOKER_AVAILABILITY_DASHBOARD_URL, '_blank')
              }
            >
              Open in Looker
            </ExternalLink>
          </Flex>
        </Card>
      </Col>
    </Row>
  </>
)

export default DashboardsPage
